export default __webpack_public_path__ + "static/media/manipulae-music.3fa3c6f9.png";